var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('card-notes',{attrs:{"items":_vm.getNotes,"headers":_vm.headers,"time-data":_vm.timeData,"items-per-page":5},on:{"delete":_vm.deleteNote,"save":_vm.saveNote,"add":_vm.addNote}})
}
var staticRenderFns = []

export { render, staticRenderFns }